import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Collapsible section with caret icon — matches the collapsible-title pattern.
 * Uses CSS transition for smooth collapse/expand animation.
 * Expanded by default; pass defaultCollapsed to start collapsed.
 */
import { useId, useState, useRef } from 'react';
export function CollapsibleSection({ title, children, className, defaultCollapsed = false }) {
    const [collapsed, setCollapsed] = useState(defaultCollapsed);
    const bodyRef = useRef(null);
    const bodyId = useId();
    return (_jsxs("div", { className: `row ${className || ''}`, children: [_jsx("h4", { className: "all-caps", children: _jsxs("button", { type: "button", className: "collapsible-title pointer", "aria-expanded": !collapsed, "aria-controls": bodyId, onClick: () => setCollapsed(!collapsed), children: [_jsx("i", { className: "fa fa-caret-down", style: {
                                transition: 'transform 0.3s ease-in-out',
                                transform: collapsed ? 'rotate(-90deg)' : 'rotate(0deg)',
                                display: 'inline-block',
                            } }), ' ', title] }) }), _jsx("div", { ref: bodyRef, id: bodyId, className: `collapse ${collapsed ? '' : 'in'}`, children: children })] }));
}
